module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Aadorf-98d64022d5a5bb5bcb4fd6f2fcb1feb7.svg";